<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card class="message-group-item">
      <h4 v-text="editing ? 'ویرایش گروه چت' : 'گروه چت جدید'" class="mb-2" />
      <b-row>
        <b-col md="12" lg="8" offset-lg="2">
          <b-row>
            <b-col md="12">
              <fm-file-select v-model="form.avatar" label="آواتار" :entity="1" />
            </b-col>
            <b-col md="6">
              <b-form-group label="عنوان">
                <b-form-input v-model="form.name" autocomplete="off" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="بیوگرافی">
                <b-form-input v-model="form.bio" autocomplete="off" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="توضیحات">
                <b-form-textarea
                    v-model="form.Description"
                    autocomplete="off"
                    rows="6"
                    no-resize
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <b-button variant="primary" class="mr-1" @click="submit">
              ذخیره
            </b-button>
            <b-button :to="{ name: 'messageGroups'}">
              بازگشت
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
export default {
  name: "MessageGroupItem",
  components: { FmFileSelect },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        bio: '',
        Description: '',
        avatar: ''
      }
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    }
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== undefined) this.getData()
      }
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.$http.get(this.$api.messenger.get, { params: { Id: this.editing } })
          .then(res => {
            this.loading = false
            this.fillForm(res.data)
          }).catch(() => {
        this.loading = false
      })
    },
    fillForm(data) {
      this.form.name = data.Name
      this.form.bio = data.Bio
      this.form.Description = data.Description
      this.form.avatar = data.Avatar
    },
    submit() {
      if (!this.form.name)
        return this.$bvToast.toast('عنوان الزامی است', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
      this.loading = true

      let data = { ...this.form }

      let url = this.editing
          ? this.$api.messenger.updateMessageGroup
          : this.$api.messenger.addMessageGroup

      if (this.editing) data.id = this.editing

      this.$http.post(url, data)
          .then(() => {
            this.loading = false
            this.$router.back()
          }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>